import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import vapidKey from './vapidkey.json'
import { messaging } from "./firebaseInit";
import { getToken } from "firebase/messaging";

const rawHTML = `
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta name="wpscanio-2697" content="ZvdRLma-6iP9cCpbWJLZw2VnxvY8NysL" />

<link href='https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic' rel='stylesheet' type='text/css'>

<!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
{'gtm.start': new Date().getTime(),event:'gtm.js'}

);var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PPD94M');</script>
<!-- End Google Tag Manager -->
<meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' />

	<!-- This site is optimized with the Yoast SEO plugin v18.8 - https://yoast.com/wordpress/plugins/seo/ -->
	<title>Five types of document fraud impacting estate agents - Property Industry Eye</title>
	<meta name="description" content="Five types of document fraud impacting estate agents - Breaking news for estate agents and the residential property industry. Independent, unbiased, and factual reporting. A forum for discussion and debate of topics of the day. Subscribe for our free daily newsletter." />
	<meta property="og:locale" content="en_GB" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Five types of document fraud impacting estate agents - Property Industry Eye" />
	<meta property="og:description" content="Five types of document fraud impacting estate agents - Breaking news for estate agents and the residential property industry. Independent, unbiased, and factual reporting. A forum for discussion and debate of topics of the day. Subscribe for our free daily newsletter." />
	<meta property="og:url" content="https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/" />
	<meta property="og:site_name" content="Property Industry Eye" />
	<meta property="article:published_time" content="2023-02-27T00:10:42+00:00" />
	<meta property="article:modified_time" content="2023-02-27T01:02:34+00:00" />
	<meta property="og:image" content="https://propertyindustryeye.com/wp-content/uploads/2021/06/Fraud.jpg" />
	<meta property="og:image:width" content="640" />
	<meta property="og:image:height" content="452" />
	<meta property="og:image:type" content="image/jpeg" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Written by" />
	<meta name="twitter:data1" content="Harriet Holmes" />
	<meta name="twitter:label2" content="Estimated reading time" />
	<meta name="twitter:data2" content="3 minutes" />
	<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebSite","@id":"https://propertyindustryeye.com/#website","url":"https://propertyindustryeye.com/","name":"Property Industry Eye","description":"","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://propertyindustryeye.com/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-GB"},{"@type":"ImageObject","inLanguage":"en-GB","@id":"https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/#primaryimage","url":"https://propertyindustryeye.com/wp-content/uploads/2021/06/Fraud.jpg","contentUrl":"https://propertyindustryeye.com/wp-content/uploads/2021/06/Fraud.jpg","width":640,"height":452},{"@type":"WebPage","@id":"https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/#webpage","url":"https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/","name":"Five types of document fraud impacting estate agents - Property Industry Eye","isPartOf":{"@id":"https://propertyindustryeye.com/#website"},"primaryImageOfPage":{"@id":"https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/#primaryimage"},"datePublished":"2023-02-27T00:10:42+00:00","dateModified":"2023-02-27T01:02:34+00:00","author":{"@id":"https://propertyindustryeye.com/#/schema/person/b3834047743db8f0ddf76c821d769fd8"},"description":"Five types of document fraud impacting estate agents - Breaking news for estate agents and the residential property industry. Independent, unbiased, and factual reporting. A forum for discussion and debate of topics of the day. Subscribe for our free daily newsletter.","breadcrumb":{"@id":"https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/#breadcrumb"},"inLanguage":"en-GB","potentialAction":[{"@type":"ReadAction","target":["https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/"]}]},{"@type":"BreadcrumbList","@id":"https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://propertyindustryeye.com/"},{"@type":"ListItem","position":2,"name":"Five types of document fraud impacting estate agents"}]},{"@type":"Person","@id":"https://propertyindustryeye.com/#/schema/person/b3834047743db8f0ddf76c821d769fd8","name":"Harriet Holmes","url":"https://propertyindustryeye.com/author/harrietholmesthirdfort-com/"}]}</script>
	<!-- / Yoast SEO plugin. -->



<link rel="alternate" type="application/rss+xml" title="Property Industry Eye &raquo; Feed"  />
<link rel="alternate" type="application/rss+xml" title="Property Industry Eye &raquo; Comments Feed" />
<link rel="alternate" type="application/rss+xml" title="Property Industry Eye &raquo; Five types of document fraud impacting estate agents Comments Feed"  />
		<script type="text/javascript">
			window._wpemojiSettings = {"baseUrl":"https:\/\/s.w.org\/images\/core\/emoji\/13.1.0\/72x72\/","ext":".png","svgUrl":"https:\/\/s.w.org\/images\/core\/emoji\/13.1.0\/svg\/","svgExt":".svg","source":{"concatemoji":"https:\/\/propertyindustryeye.com\/wp-includes\/js\/wp-emoji-release.min.js?ver=5399a202ce0691496d05523f56bbfa49"}};
			!function(e,a,t){var n,r,o,i=a.createElement("canvas"),p=i.getContext&&i.getContext("2d");function s(e,t){var a=String.fromCharCode;p.clearRect(0,0,i.width,i.height),p.fillText(a.apply(this,e),0,0);e=i.toDataURL();return p.clearRect(0,0,i.width,i.height),p.fillText(a.apply(this,t),0,0),e===i.toDataURL()}function c(e){var t=a.createElement("script");t.src=e,t.defer=t.type="text/javascript",a.getElementsByTagName("head")[0].appendChild(t)}for(o=Array("flag","emoji"),t.supports={everything:!0,everythingExceptFlag:!0},r=0;r<o.length;r++)t.supports[o[r]]=function(e){if(!p||!p.fillText)return!1;switch(p.textBaseline="top",p.font="600 32px Arial",e){case"flag":return s([127987,65039,8205,9895,65039],[127987,65039,8203,9895,65039])?!1:!s([55356,56826,55356,56819],[55356,56826,8203,55356,56819])&&!s([55356,57332,56128,56423,56128,56418,56128,56421,56128,56430,56128,56423,56128,56447],[55356,57332,8203,56128,56423,8203,56128,56418,8203,56128,56421,8203,56128,56430,8203,56128,56423,8203,56128,56447]);case"emoji":return!s([10084,65039,8205,55357,56613],[10084,65039,8203,55357,56613])}return!1}(o[r]),t.supports.everything=t.supports.everything&&t.supports[o[r]],"flag"!==o[r]&&(t.supports.everythingExceptFlag=t.supports.everythingExceptFlag&&t.supports[o[r]]);t.supports.everythingExceptFlag=t.supports.everythingExceptFlag&&!t.supports.flag,t.DOMReady=!1,t.readyCallback=function(){t.DOMReady=!0},t.supports.everything||(n=function(){t.readyCallback()},a.addEventListener?(a.addEventListener("DOMContentLoaded",n,!1),e.addEventListener("load",n,!1)):(e.attachEvent("onload",n),a.attachEvent("onreadystatechange",function(){"complete"===a.readyState&&t.readyCallback()})),(n=t.source||{}).concatemoji?c(n.concatemoji):n.wpemoji&&n.twemoji&&(c(n.twemoji),c(n.wpemoji)))}(window,document,window._wpemojiSettings);
		</script>
		<style type="text/css">
img.wp-smiley,
img.emoji {
	display: inline !important;
	border: none !important;
	box-shadow: none !important;
	height: 1em !important;
	width: 1em !important;
	margin: 0 .07em !important;
	vertical-align: -0.1em !important;
	background: none !important;
	padding: 0 !important;
}
</style>
	<link rel='stylesheet' id='wp-block-library-css'  href='https://propertyindustryeye.com/wp-includes/css/dist/block-library/style.min.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<style id='wp-block-library-inline-css' type='text/css'>
.has-text-align-justify{text-align:justify;}
</style>
<link rel='stylesheet' id='mediaelement-css'  href='https://propertyindustryeye.com/wp-includes/js/mediaelement/mediaelementplayer-legacy.min.css?ver=4.2.16' type='text/css' media='all' />
<link rel='stylesheet' id='wp-mediaelement-css'  href='https://propertyindustryeye.com/wp-includes/js/mediaelement/wp-mediaelement.min.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='cookie-law-info-css'  href='https://propertyindustryeye.com/wp-content/plugins/cookie-law-info/public/css/cookie-law-info-public.css?ver=2.0.5' type='text/css' media='all' />
<link rel='stylesheet' id='cookie-law-info-gdpr-css'  href='https://propertyindustryeye.com/wp-content/plugins/cookie-law-info/public/css/cookie-law-info-gdpr.css?ver=2.0.5' type='text/css' media='all' />
<link rel='stylesheet' id='easy_author_image-css'  href='https://propertyindustryeye.com/wp-content/plugins/easy-author-image/css/easy-author-image.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='incito_banner-styles-css'  href='https://propertyindustryeye.com/wp-content/plugins/eye-adverts/css/incito.css?ver=1.1.4' type='text/css' media='all' />
<link rel='stylesheet' id='pie-podcasts-css'  href='https://propertyindustryeye.com/wp-content/plugins/pie-podcasts/public/css/pie-podcasts-public.css?ver=1.0.0' type='text/css' media='all' />
<link rel='stylesheet' id='unslider-styles-css'  href='https://propertyindustryeye.com/wp-content/plugins/property-eye-adverts/css/unslider.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='pienewsletter-css'  href='https://propertyindustryeye.com/wp-content/plugins/property-eye-newsletter/assets/css/pienewsletter.css?ver=1.1' type='text/css' media='all' />
<link rel='stylesheet' id='userpie-css'  href='https://propertyindustryeye.com/wp-content/plugins/property-eye-user/assets/css/userpie.css?ver=1.24' type='text/css' media='all' />
<link rel='stylesheet' id='intl-tel-css'  href='https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='stcr-font-awesome-css'  href='https://propertyindustryeye.com/wp-content/plugins/subscribe-to-comments-reloaded/includes/css/font-awesome.min.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='widgetopts-styles-css'  href='https://propertyindustryeye.com/wp-content/plugins/widget-options/assets/css/widget-options.css' type='text/css' media='all' />
<link rel='stylesheet' id='wordpress-popular-posts-css-css'  href='https://propertyindustryeye.com/wp-content/plugins/wordpress-popular-posts/assets/css/wpp.css?ver=5.0.2' type='text/css' media='all' />
<link rel='stylesheet' id='mailchimp-for-wp-checkbox-css'  href='https://propertyindustryeye.com/wp-content/plugins/mailchimp-for-wp/assets/css/checkbox.min.css?ver=2.3.14' type='text/css' media='all' />
<link rel='stylesheet' id='pie-main-style-css'  href='https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/css/style.css?ver=1.4.2' type='text/css' media='all' />
<link rel='stylesheet' id='propertyeyetheme-style-css'  href='https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/style.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='mailchimp-for-wp-form-css'  href='https://propertyindustryeye.com/wp-content/plugins/mailchimp-for-wp/assets/css/form.min.css?ver=2.3.14' type='text/css' media='all' />
<link rel='stylesheet' id='yop-public-css'  href='https://propertyindustryeye.com/wp-content/plugins/yop-poll-pro/public/assets/css/yop-poll-public-6.3.0.css?ver=5399a202ce0691496d05523f56bbfa49' type='text/css' media='all' />
<link rel='stylesheet' id='jetpack_css-css'  href='https://propertyindustryeye.com/wp-content/plugins/jetpack/css/jetpack.css?ver=10.1' type='text/css' media='all' />
<link rel='stylesheet' id='like-dislike-css'  href='https://propertyindustryeye.com/wp-content/plugins/like-dislike-counter-for-posts-pages-and-comments/css/ldc-lite.css?ver=1.0.0' type='text/css' media='all' />
<script type='text/javascript' src='https://propertyindustryeye.com/wp-includes/js/jquery/jquery.min.js?ver=3.6.0' id='jquery-core-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-includes/js/jquery/jquery-migrate.min.js?ver=3.3.2' id='jquery-migrate-js'></script>
<script type='text/javascript' id='cookie-law-info-js-extra'>
/* <![CDATA[ */
var Cli_Data = {"nn_cookie_ids":[],"cookielist":[],"non_necessary_cookies":[],"ccpaEnabled":"","ccpaRegionBased":"","ccpaBarEnabled":"","strictlyEnabled":["necessary","obligatoire"],"ccpaType":"gdpr","js_blocking":"","custom_integration":"","triggerDomRefresh":"","secure_cookies":""};
var cli_cookiebar_settings = {"animate_speed_hide":"500","animate_speed_show":"500","background":"#fff","border":"#444","border_on":"","button_1_button_colour":"#e20000","button_1_button_hover":"#b50000","button_1_link_colour":"#fff","button_1_as_button":"1","button_1_new_win":"","button_2_button_colour":"#333","button_2_button_hover":"#292929","button_2_link_colour":"#0a0a0a","button_2_as_button":"","button_2_hidebar":"1","button_3_button_colour":"#000","button_3_button_hover":"#000000","button_3_link_colour":"#fff","button_3_as_button":"1","button_3_new_win":"1","button_4_button_colour":"#000","button_4_button_hover":"#000000","button_4_link_colour":"#fff","button_4_as_button":"1","button_7_button_colour":"#61a229","button_7_button_hover":"#4e8221","button_7_link_colour":"#fff","button_7_as_button":"1","button_7_new_win":"","font_family":"inherit","header_fix":"","notify_animate_hide":"1","notify_animate_show":"1","notify_div_id":"#cookie-law-info-bar","notify_position_horizontal":"right","notify_position_vertical":"bottom","scroll_close":"","scroll_close_reload":"","accept_close_reload":"1","reject_close_reload":"1","showagain_tab":"","showagain_background":"#fff","showagain_border":"#000","showagain_div_id":"#cookie-law-info-again","showagain_x_position":"100px","text":"#000","show_once_yn":"","show_once":"10000","logging_on":"","as_popup":"","popup_overlay":"1","bar_heading_text":"","cookie_bar_as":"banner","popup_showagain_position":"bottom-right","widget_position":"left"};
var log_object = {"ajax_url":"https:\/\/propertyindustryeye.com\/wp-admin\/admin-ajax.php"};
/* ]]> */
</script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/plugins/cookie-law-info/public/js/cookie-law-info-public.js?ver=2.0.5' id='cookie-law-info-js'></script>
<script type='text/javascript' src='https://www.google.com/recaptcha/api.js?ver=5399a202ce0691496d05523f56bbfa49' id='recaptcha-js'></script>
<script type='text/javascript' id='wpp-js-js-extra'>
/* <![CDATA[ */
var wpp_params = {"sampling_active":"0","sampling_rate":"100","ajax_url":"https:\/\/propertyindustryeye.com\/wp-json\/wordpress-popular-posts\/v1\/popular-posts","ID":"122561","token":"041f93f1c2","debug":""};
/* ]]> */
</script>
<script type='text/javascript' id='wpp-js-js'></script>
<script type='text/javascript' src='//platform-api.sharethis.com/js/sharethis.js#product=ga&#038;property=622bd99d58f4c400136865b9' id='googleanalytics-platform-sharethis-js'></script>
<link rel="https://api.w.org/" /><link rel="alternate" type="application/json" href="https://propertyindustryeye.com/wp-json/wp/v2/posts/122561" /><link rel="EditURI" type="application/rsd+xml" title="RSD" href="https://propertyindustryeye.com/xmlrpc.php?rsd" />
<link rel="wlwmanifest" type="application/wlwmanifest+xml" href="https://propertyindustryeye.com/wp-includes/wlwmanifest.xml" /> 

<link rel='shortlink' href='https://propertyindustryeye.com/?p=122561' />
<link rel="alternate" type="application/json+oembed" href="https://propertyindustryeye.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F" />
<link rel="alternate" type="text/xml+oembed" href="https://propertyindustryeye.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F&#038;format=xml" />
	<script type="text/javascript" >
	jQuery(function ($)
	{
		$( '.countable_link' ).on( 'click ', function()
		{
			var self = $( this );
			var post_id = self.attr( "post_id" );
			var nonce = self.attr( "ref" );
			var ajax_options = {
				action: 'link_click_counter',
				nonce: nonce,
				ajaxurl: 'https://propertyindustryeye.com/wp-admin/admin-ajax.php',
				post_id: post_id
			};

       		$.post( ajax_options.ajaxurl, ajax_options, function()
			{
            	return true;
				//window.location.href = self.attr( "href" );
        	});
        	//return false;
    	});
	});
	</script>

		<!-- GA Google Analytics @ https://m0n.co/ga -->
		<script async src="https://www.googletagmanager.com/gtag/js?id=UA-20049997-7"></script>
		<script>
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', 'UA-20049997-7');
		</script>

	    <script type="text/javascript" >

        jQuery(function ($) {
            $( '.clickable_link' ).on( 'click', function() {

				var self = $( this );
				var post_id = self.attr( "post_id" );
				var nonce = self.attr( "ref" );
				var type = self.attr( "type" );
            
			    jQuery(document).ready(function($) {
                    $.ajax({
						url: 'https://propertyindustryeye.com/wp-admin/admin-ajax.php',
						type: 'post',
						data: {
							'action': 'advert_click_counter',
                        	'nonce': nonce,
                        	'post_id': post_id,
							'type': type
            			}
					})
            		
         		});
           });
        });

    </script>
<style type='text/css'>img#wpstats{display:none}</style>
		<script type="text/javascript">
  jQuery(function($){
    $('.comment-reply-link').click(function(e){
      e.preventDefault();
      var args = $(this).attr('href');
      args = args.replace(/.*\(|\)/gi, '').replace(/\"|\s+/g, '');
      args = args.split(',');
      tinymce.EditorManager.execCommand('mceRemoveEditor', true, 'comment');
      addComment.moveForm.apply( addComment, args );
      tinymce.EditorManager.execCommand('mceAddEditor', true, 'comment');
    });

    $('#cancel-comment-reply-link').click(function(e){
        e.preventDefault();
        tinymce.EditorManager.execCommand('mceRemoveEditor', true, 'comment');
        setTimeout(function(){ tinymce.EditorManager.execCommand('mceAddEditor', true, 'comment'); }, 1);
    });
  });
</script>
    <script data-ad-client="ca-pub-6108146675509839" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
    <!-- Meta Pixel Code -->
    <script>
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '597713121327463');
        fbq('track', 'PageView');
    </script>
    <noscript><img height="1" width="1" style="display:none"
                   src="https://www.facebook.com/tr?id=597713121327463&ev=PageView&noscript=1"
        /></noscript>
    <!-- End Meta Pixel Code -->
</head>

<body class="post-template-default single single-post postid-122561 single-format-standard group-blog">
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PPD94M"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
    <div id="page" class="site">
        <header id="masthead" class="site-header" role="banner">
            <div class="container">
                <div class="site-branding">
                    <a href="#" rel="home">
						<img src="https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/images/property-industry-eye.png" alt="Property Industry Eye Logo" />
                    </a>
                </div><!-- .site-branding -->
        		<div class="site-nav">
                    <nav id="site-navigation" class="main-navigation" role="navigation">
                        <button class="menu-toggle" aria-controls="primary-menu" aria-expanded="false">Primary Menu</button>
                        <div class="menu-main-navigation-container"><ul id="main-menu" class="menu"><li id="menu-item-24010" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-24010"><a href="#">HOME</a></li>
<li id="menu-item-24014" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24014"><a href="/news">NEWS ARCHIVE</a></li>
<li id="menu-item-24012" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-24012"><a href="#">CONTACT US</a></li>
<li id="menu-item-24013" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-24013"><a href="#">ADVERTISE</a></li>
</ul></div>                        						                            <ul class="register-nav">
                                <li><a href="https://propertyindustryeye.com/login">Login</a></li>
                                <li><a href="https://propertyindustryeye.com/register">Register</a></li>
                            </ul>
                                                </nav><!-- #site-navigation -->
                    <div class="socialmedia">
                    	<a href="#" target="_blank"><img src="https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/images/icon-twitter.jpg" alt="Property Industry Eye Twitter Page" /></a>
                    	<a href="#" target="_blank"><img src="https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/images/icon-facebook.jpg" alt="Property Industry Eye Facebook Page" /></a>
                        <a href="#" target="_blank"><img src="https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/images/icon-linkedin.jpg" alt="Property Industry Eye LinkedIn Page" /></a>
                    	<a href="#" target="_blank"><img src="https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/images/icon-rss.jpg" alt="Property Industry Eye RSS Feed" /></a>
                    </div>
                    <div style="float:right;width:100%;">
                        <div class="search">
                            <form class="navbar-form" role="search" method="get" id="searchform" action="https://propertyindustryeye.com" >
                                <div class="input-group">
                                    <input type="text" id="searchbox" class="form-control" placeholder="Search" name="s" id="s">
                                </div>
                            </form>
                        </div>
                        <div class="award">
                            THE AWARD-WINNING PROPERTY TRADE MAGAZINE
                        </div>
                    </div>
				</div>
            </div>
        </header><!-- #masthead -->

        <div class="register-bar">
        	<div class="container">
                <div class="edited-by">
                    <div class="drop-float">
                        <div class="no-margin">
                            <h2>WHERE NEWS COMES FIRST</h2>
                        </div>
                    </div>
                </div>
                <div class="register-menu">
                                                    <ul class="register-nav">
                                <li><a href="#">Login</a></li>
                                <li><a href="#">Register</a></li>
                            </ul>
                                           </div>
			</div>
        </div>

        <div id="content" class="site-content">
            <div class="container">

    <div class='banner-ad'><a href="https://expert.onthemarket.com/agent-testimonials/?utm_source=PIE&utm_medium=banner&utm_campaign=PIE" title="OTM 3" rel="nofollow" target="_blank" ref="dcd2999dfe" post_id="111041" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2022/04/PIE-1200x150-Testimonial_3-–-10.png" alt="OTM 3" width="1200"></a></div>
	<div id="primary" class="content-area news-article-page">
		<main id="main" class="site-main" role="main">

			<!-- ARTICLE START -->

		
<script type="text/javascript">
    function backToArticles()
    {
        if (!location.origin) {
            location.origin = location.protocol + "//" + location.host;
        }

        if(location.origin+"/" == document.referrer) {
            window.location = "/";
        }
        else {
            window.location = "/news";
        }
    }
</script>

<article id="post-122561" class="post-122561 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
	<header class="entry-header">
		<h1 class="entry-title">Five types of document fraud impacting estate agents</h1>		<div class="entry-meta">
			<span class="posted-on"><a rel="bookmark"><time class="entry-date published" datetime="2023-02-27T00:10:42+00:00">February 27, 2023</time><time class="updated" datetime="2023-02-27T01:02:34+00:00">February 27, 2023</time></a></span><span class="byline"> | <span class="author vcard"><a class="url fn n" href="#">Harriet Holmes</a></span></span>		</div><!-- .entry-meta -->
			</header><!-- .entry-header -->
	<div class="social-bar">
    	<span class="social-link"><span class="facebook">
					<iframe allowtransparency="true" style="border: medium none; overflow: hidden; width: 70px; height: 21px; margin:6px 0 0 0;" frameborder="0" scrolling="no"></iframe>
				</span><span class="twitter">
					<iframe allowtransparency="true" src="https://platform.twitter.com/widgets/tweet_button.html?counturl=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F&amp;count=horizontal&amp;text=Five%20types%20of%20document%20fraud%20impacting%20estate%20agents&amp;url=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F" _mce_src="http://platform.twitter.com/widgets/tweet_button.html" style="border: medium none; overflow: hidden; width: 70px; height: 21px;" _mce_style="border: none; overflow: hidden; width: 70px; height: 21px;" frameborder="0" scrolling="no"></iframe>
				</span><span class="email2friend">Email to a friend</span></span>        <span class="nav-containter article-navigation">
            <div class="nav-links back-to-home">
                <a href="/" >Back to Homepage</a>
            </div>
            
	<nav class="navigation post-navigation" role="navigation" aria-label="Posts">
		<h2 class="screen-reader-text">Post navigation</h2>
		<div class="nav-links"><div class="nav-previous"><a href="#" rel="prev">Next</a></div><div class="nav-next"><a href="#" rel="next">New partnership to help agents remain compliant</a></div></div>
	</nav>
        </span>

        <span class="print"><a rel="nofollow" title="print this article" onclick="window.print()" href="#"> Print</a></span>
	</div>
	<div class="entry-content article-content">
		<p><a href="https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud.jpg"><img loading="lazy" class="size-medium wp-image-104399 alignright" src="https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud-336x237.jpg" alt="" width="336" height="237" srcset="https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud-336x237.jpg 336w, https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud-771x545.jpg 771w, https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud-768x543.jpg 768w, https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud-1536x1086.jpg 1536w, https://propertyindustryeye.com/wp-content/uploads/2021/10/Fraud.jpg 1920w" sizes="(max-width: 336px) 100vw, 336px" /></a>Property fraud is a significant and growing risk. Often fraudsters can perpetrate such fraud by using fake or fraudulent documents.</p>
<p>So, as regulated professionals, estate agents need to be able to spot such documents and ensure they do not fall foul of document fraud.</p>
<p><strong>What is it?</strong></p>
<p>Document fraud is the act of creating, altering, or using false or genuine documents with the intent to deceive or pass specific controls.</p>
<p>Criminals may use fraudulent documents to enter the UK illegally, obtain employment, banking, or legal services, housing, access to sites and hire vehicles for unlawful purposes.</p>
<p>There are two broad categories of fraudulent documents, false and genuine documents used for fraud.</p>
<p>False documents include counterfeit, forgeries and pseudo or fantasy documents.</p>
<p>A counterfeit document is one that has been made from scratch to resemble an officially issued document but is an unauthorised reproduction. Even for experts, high-quality counterfeits can take time and be difficult to identify.</p>
<p>A forged document is a genuine document altered for a criminal purpose. Altering photographs and personal details are typical examples, but pages, visas and stamps may also be forged.</p>
<p>Pseudo or fantasy documents have no legal basis and are usually not based on any legitimate document but may have the physical appearance of a passport or identity card. However, they are not officially recognised and are not acceptable proof of either nationality or identity.</p>
<p>Genuine documents used for fraud may include genuine documents obtained through theft, robbery, or corruption. Such documents may also include those that an impostor misuses. This can include situations where the possessor of the document may look like the rightful owner.</p>
<p><strong>What are the risks?</strong></p>
<p>Agents that miss the opportunity to identify red flags around identification documents may inadvertently enable criminal and fraudulent activity.</p>
<p>If an agent has missed such a document through carelessness, they may be subject to civil penalties or criminal prosecution, including fines, a prison term and reputational damage.</p>
<p>As a result, document verification is critical for agents and their firms.</p>
<p>Estate agents must seek to confirm the authenticity of relevant documentation they rely on as client due diligence.</p>
<p>Manual review is vulnerable to human error. It is also costly and time-consuming.</p>
<p>What’s more, as fraudsters and the documents they use become more sophisticated, agents must ensure they keep up to date with the latest developments.</p>
<p><strong>How can technology help?</strong></p>
<p>Automating document verification can reduce the pressure on staff, improve the customer onboarding experience and help prevent fraud.</p>
<p>Some tools use the latest technology, such as artificial intelligence and biometric data, to check documents for signs of tampering, forgery and counterfeiting.</p>
<p>Robust platforms will run a document through a database to determine whether the document has been reported to the police as lost or stolen.</p>
<p>Document verification as part of an agent’s identity verification process will help ensure that a person is who they claim to be and that the agent hasn’t been provided with a false document.</p>
<p>Overall, it helps prevent criminals from successfully using a fake or false document to commit fraud, helping protect agents and their legitimate clients.</p>
<p><strong><em>Harriet Holmes, AML services manager at</em> <em>Thirdfort</em><em>, a risk management platform combining Know Your Client, Anti-Money Laundering and Source of Funds verification.</em></strong></p>
<p>&nbsp;</p>

	</div><!-- .entry-content -->

	<div class="social-bar">
    	<span class="social-link"><span class="facebook">
					<iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F&amp;layout=button_count&amp;show_faces=false&amp;width=70&amp;action=like&amp;font=arial&amp;colorscheme=light" allowtransparency="true" style="border: medium none; overflow: hidden; width: 70px; height: 21px; margin:6px 0 0 0;" frameborder="0" scrolling="no"></iframe>
				</span><span class="twitter">
					<iframe allowtransparency="true" src="https://platform.twitter.com/widgets/tweet_button.html?counturl=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F&amp;count=horizontal&amp;text=Five%20types%20of%20document%20fraud%20impacting%20estate%20agents&amp;url=https%3A%2F%2Fpropertyindustryeye.com%2Ffive-types-of-document-fraud-impacting-estate-agents%2F" _mce_src="http://platform.twitter.com/widgets/tweet_button.html" style="border: medium none; overflow: hidden; width: 70px; height: 21px;" _mce_style="border: none; overflow: hidden; width: 70px; height: 21px;" frameborder="0" scrolling="no"></iframe>
				</span><span class="email2friend">Email to a friend</span></span>        <span class="nav-containter article-navigation">
            <div class="nav-links back-to-home">
                <a href="/" >Back to Homepage</a>
            </div>
            
	<nav class="navigation post-navigation" role="navigation" aria-label="Posts">
		<h2 class="screen-reader-text">Post navigation</h2>
		<div class="nav-links"><div class="nav-previous"><a href="#" rel="prev">Next</a></div><div class="nav-next"><a href="#" rel="next">New partnership to help agents remain compliant</a></div></div>
	</nav>
        </span>

        <span class="print"><a rel="nofollow" title="print this article" onclick="window.print()" href="#"> Print</a></span>
	</div>
</article><!-- #post-## -->

<section style='border-bottom: 1px solid #999999; display: block; margin-bottom: 10px; padding-bottom: 10px;'><a href="https://communications.homesearch.co.uk/new-homesearch" title="Homesearch EOS" rel="nofollow" target="_blank" ref="80819c6823" post_id="111430" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2022/04/PIE_End_of_Story_Sept_22_art_7.jpg" alt="Homesearch EOS" width="860"></a></section>
<script src='https://www.google.com/recaptcha/api.js'></script>
<div class="email2friend-modal">
  <span class="close">x</span>
  <h4>Email the story to a friend</h4>
  <form action="https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/" method="post">
    <div class="form">
        <input type="hidden" name="e2f_post" value="https://propertyindustryeye.com/five-types-of-document-fraud-impacting-estate-agents/">
        <p>
          <input type="text" class="control" name="e2f_name" placeholder="Your Name" required>
        </p>
        <p>
          <input type="email" class="control" name="e2f_email" placeholder="Recipients Email Address" required>
        </p>
        <p>
          <textarea rows="4" class="control" name="e2f_message" placeholder="Message" required></textarea>
        </p>
        <div class="g-recaptcha" data-sitekey="6Lf9miUUAAAAAJqV647bzwXrcHi0SqmyBkfvch0f"></div>
        <p>
          <button>Send</button>
        </p>
    </div>
    <div class="notices"></div>
    <div class="loader">
        <svg class="rotator" width="30px" height="30px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="138.2300767579509 113.09733552923254" stroke="#d32229" fill="none" stroke-width="20" transform="rotate(16.6032 50 50)"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>
    </div>
  </form>
</div>
<div class="otherTopStories">
    <h2>More top news stories</h2>
    
<article id="post-122674" class="news-article post-122674 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
	<header class="entry-header">
		<h1 class="entry-title"><a href="#" rel="bookmark">Dexters acquires another well-established agency</a></h1>	</header><!-- .entry-header -->

	<div class="entry-content">
		<a class="read-more" href="#">Continue Reading ...</a>	</div><!-- .entry-content -->

</article><!-- #post-## -->

<article id="post-122638" class="news-article post-122638 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
	<header class="entry-header">
		<h1 class="entry-title"><a href="#" rel="bookmark">The holy grail of solving the problem of home buying and selling has finally been found</a></h1>	</header><!-- .entry-header -->

	<div class="entry-content">
		<a class="read-more" href="#">Continue Reading ...</a>	</div><!-- .entry-content -->

</article><!-- #post-## -->

<article id="post-122679" class="news-article post-122679 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
	<header class="entry-header">
		<h1 class="entry-title"><a href="#" rel="bookmark">Douglas &#038; Gordon CEO James Evans sets up new estate agency after firm goes into administration</a></h1>	</header><!-- .entry-header -->

	<div class="entry-content">
		<a class="read-more" href="#">Continue Reading ...</a>	</div><!-- .entry-content -->

</article><!-- #post-## -->
</div>
<br /><br />
<div id="comments" class="comments-area">

		<div id="respond" class="comment-respond">
		<h3 id="reply-title" class="comment-reply-title">Leave a reply <small><a rel="nofollow" id="cancel-comment-reply-link" href="/five-types-of-document-fraud-impacting-estate-agents/#respond" style="display:none;">Cancel reply</a></small></h3><p class="must-log-in">You must be <a href="#">logged in</a> to post a comment.</p>
              <p>If you want to create a user account so you can log in, <a href="#">click here</a></p><!-- Subscribe to Comments Reloaded version 200205 --><!-- Subscribe to comments Reloaded MP: '/comment-subscriptions/' --><!-- BEGIN: subscribe to comments reloaded --><p class='comment-form-subscriptions'><label for='subscribe-reloaded'><input style='width:30px' type='checkbox' name='subscribe-reloaded' id='subscribe-reloaded' value='yes' /> Notify me by email when a comment is made to this post. You can manage these notifications <a href="http://[manager_link]">here</a>. You can also <a href="https://propertyindustryeye.com/comment-subscriptions/?srp=122561&amp;srk=34d7397829997ab761b4f06e4bcfb74a&amp;sra=s&amp;srsrc=f">subscribe</a> without commenting.</label></p><!-- END: subscribe to comments reloaded -->	</div><!-- #respond -->
	
</div><!-- #comments -->
			<!-- ARTICLE END -->

			    <div class="newsletter-signup post">
      <div class="top">
        <h2>
          Daily news email from EYE
        </h2>
        <p>Enter your email below to receive the latest news each morning direct to your inbox.</p>
      </div>
      <div class="signup-form">
        <div class="form pie_newsletter-form">
          <div class="loader">
            <svg width='30px' height='30px' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring rotator"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="138.2300767579509 113.09733552923254" stroke="#d32229" fill="none" stroke-width="20"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>
          </div>
          <form method="post">
            <p>
              <input type="email" id="pie_newsletter_email" name="pie_newsletter_email" placeholder="Enter your email address" required="">
              <input value="Subscribe" type="submit">
            </p>

            <div style="position: absolute; left: -5000px;">
              <input type="text" name="pie_newsletter_76a81bda6c1ec7257aa7badfec99a2e4" value="" autocomplete="off">
            </div>
          </form>
          <div class="success"></div>
        </div>
      </div>
    </div>

    <div class="register-popup">
      <div class="register-popup-body">
        <p class="register-popup-info">
          <b>Thank you for signing up to our newsletter, we have sent you an email asking you to confirm your subscription.</b> Additionally if you would like to create a free EYE account which allows you to comment on news stories and manage your email subscriptions please enter a password below.
        </p>
        <div class="register-popup-form">
          <input type="hidden" name="register-popup-email">
          <input type="hidden" name="register-popup-nonce" value="27b839ccea">
          <input type="password" name="register-popup-password" placeholder="Enter your password...">
        </div>
        <p class="register-popup-alert"></p>
        <div class="register-popup-buttons">
          <button class="register-popup-create">Create Account</button>
          <button class="register-popup-cancel">Cancel</button>
        </div>
        <div class="loader">
          <svg class="rotator" width='30px' height='30px' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="138.2300767579509 113.09733552923254" stroke="#fff" fill="none" stroke-width="20"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>
        </div>
      </div>
    </div>
    			
		</main><!-- #main -->
	</div><!-- #primary -->

	<aside id="secondary" class="eye-adverts" role="complementary">
		<!-- ADVERT START -->
		<a href="https://www.homeppl.com/fraud-finder/fraud-finder-lp/?utm_source=industry_eye&utm_medium=banner" title="HomePPL 2" rel="nofollow" target="_blank" ref="dcf899d2a2" post_id="121306" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/01/Banner-2-PIE-1-1.png" alt="HomePPL 2" width="834"></a><a href="https://advantage.zpg.co.uk/list-with-zoopla/?utm_source=propertyindustryeye&utm_medium=trade-display&utm_campaign=always-on&utm_term=&utm_content=" title="Zoopla 2" rel="nofollow" target="_blank" ref="de0b9af388" post_id="121163" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/01/Google-display-300x250px-option-2-2.png" alt="Zoopla 2" width="300"></a><a href="https://www.billingbetter.co.uk/agents?utm_source=PIE&utm_medium=banner&utm_campaign=winter-duration&utm_id=PIEbb-website-banner-1#video" title="Billing Better 2" rel="nofollow" target="_blank" ref="679edf1d39" post_id="121717" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/02/PIE-2.png" alt="Billing Better 2" width="1253"></a><a href="https://capitalletters.org.uk/?utm_campaign=Rentsurance&utm_source=property_eye&utm_medium=website_banner" title="Capital Letters" rel="nofollow" target="_blank" ref="b6d6e24122" post_id="122012" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/02/Property-Eye-Website-Banner_final.jpg" alt="Capital Letters" width="300"></a><a href="https://www.theprs.co.uk/PropertyAgent/JoinNow?utm_source=referral&utm_medium=banner&utm_campaign=prs_switch_pie&utm_content=switch_to_prs" title="Property Redress Scheme" rel="nofollow" target="_blank" ref="0e27b4784f" post_id="122633" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/02/Large-Website-Banner-PIE.jpg" alt="Property Redress Scheme" width="300"></a><a href="https://info.goodlord.co/your-guide-to-lettings-and-the-law-2023?utm_campaign=PIE-EBOOK-LATL&utm_source=banner" title="Goodlord" rel="nofollow" target="_blank" ref="cb69c29a1d" post_id="121474" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/01/LATL_2023-Q1_-PIE_banner.png" alt="Goodlord" width="300"></a><a href="https://www.thirdfort.com/property/?utm_campaign=PIE+Display+2022&utm_source=Property+Industry+Eye&utm_medium=display+banner" title="Thirdfort 2" rel="nofollow" target="_blank" ref="b32b83eb7d" post_id="114637" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2022/07/Thirdfort-PIE-2.png" alt="Thirdfort 2" width="300"></a><a href="https://viewber.co.uk/?utm_source=PIE&utm_medium=Display&utm_campaign=23&utm_content=Img" title="Viewber EA2030" rel="nofollow" target="_blank" ref="bfbbc1b946" post_id="122362" class="countable_link"><img src="https://propertyindustryeye.com/wp-content/uploads/2023/02/viewber-300x150-1.png" alt="Viewber EA2030" width="300"></a>		<!-- ADVERT END -->

        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
        <!-- Side Column Adverts -->
        <ins class="adsbygoogle"
             style="display:block"
             data-ad-client="ca-pub-6108146675509839"
             data-ad-slot="7012016741"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
        <script>
            (adsbygoogle = window.adsbygoogle || []).push({});
        </script>
	</aside><!-- #secondary -->

			</div>
        </div><!-- #content -->

		<footer id="colophon" class="site-footer" role="contentinfo">
			<div class="container">
                <div class="footer-nav">
					<div class="menu-footer-navigation-container"><ul id="footer-menu" class="menu"><li id="menu-item-24008" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-24008"><a href="#">HOME</a></li>
<li id="menu-item-860" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-860"><a href="#">ABOUT US</a></li>
<li id="menu-item-995" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-995"><a href="#">PRIVACY</a></li>
<li id="menu-item-57158" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-57158"><a href="#">COOKIES</a></li>
<li id="menu-item-1002" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1002"><a href="#">TERMS</a></li>
<li id="menu-item-24009" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-24009"><a href="#">REPORT A FAULT</a></li>
</ul></div>				</div><!-- .site-info -->
            </div>
		</footer><!-- #colophon -->

	</div><!-- #page --> 


  
  <!--<div class="newsletter-popup">
    <span class="close">x</span>
      </div>-->

  

<!--googleoff: all--><div id="cookie-law-info-bar" data-nosnippet="true"><span>This website uses cookies for analytics and personalization. By continuing to browse, you agree to our <a href='http://www.propertyindustryeye.com/cookie-policy/' id="CONSTANT_OPEN_URL"  class="cli-plugin-main-link"  style="display:inline-block;" >Cookie Policy</a>.         <a role='button' tabindex='0' data-cli_action="accept" id="cookie_action_close_header"  class="medium cli-plugin-button cli-plugin-main-button cookie_action_close_header cli_action_button" style="display:inline-block; ">Accept</a></span></div><div id="cookie-law-info-again" style="display:none;" data-nosnippet="true"><span id="cookie_hdr_showagain">Privacy & Cookies Policy</span></div><div class="cli-modal" data-nosnippet="true" id="cliSettingsPopup" tabindex="-1" role="dialog" aria-labelledby="cliSettingsPopup" aria-hidden="true">
  <div class="cli-modal-dialog" role="document">
	<div class="cli-modal-content cli-bar-popup">
	  	<button type="button" class="cli-modal-close" id="cliModalClose">
			<svg class="" viewBox="0 0 24 24"><path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path><path d="M0 0h24v24h-24z" fill="none"></path></svg>
			<span class="wt-cli-sr-only">Close</span>
	  	</button>
	  	<div class="cli-modal-body">
			<div class="cli-container-fluid cli-tab-container">
	<div class="cli-row">
		<div class="cli-col-12 cli-align-items-stretch cli-px-0">
			<div class="cli-privacy-overview">
				<h4>Privacy Overview</h4>				<div class="cli-privacy-content">
					<div class="cli-privacy-content-text">This website uses cookies to improve your experience while you navigate through the website. Out of these, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may affect your browsing experience.</div>
				</div>
				<a class="cli-privacy-readmore"  aria-label="Show more" tabindex="0" role="button" data-readmore-text="Show more" data-readless-text="Show less"></a>			</div>
		</div>
		<div class="cli-col-12 cli-align-items-stretch cli-px-0 cli-tab-section-container">
												<div class="cli-tab-section">
						<div class="cli-tab-header">
							<a role="button" tabindex="0" class="cli-nav-link cli-settings-mobile" data-target="necessary" data-toggle="cli-toggle-tab">
								Necessary							</a>
							<div class="wt-cli-necessary-checkbox">
                        <input type="checkbox" class="cli-user-preference-checkbox"  id="wt-cli-checkbox-necessary" data-id="checkbox-necessary" checked="checked"  />
                        <label class="form-check-label" for="wt-cli-checkbox-necessary">Necessary</label>
                    </div>
                    <span class="cli-necessary-caption">Always Enabled</span> 						</div>
						<div class="cli-tab-content">
							<div class="cli-tab-pane cli-fade" data-id="necessary">
								<div class="wt-cli-cookie-description">
									Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.								</div>
							</div>
						</div>
					</div>
																	<div class="cli-tab-section">
						<div class="cli-tab-header">
							<a role="button" tabindex="0" class="cli-nav-link cli-settings-mobile" data-target="non-necessary" data-toggle="cli-toggle-tab">
								Non-necessary							</a>
							<div class="cli-switch">
                        <input type="checkbox" id="wt-cli-checkbox-non-necessary" class="cli-user-preference-checkbox"  data-id="checkbox-non-necessary"  checked='checked' />
                        <label for="wt-cli-checkbox-non-necessary" class="cli-slider" data-cli-enable="Enabled" data-cli-disable="Disabled"><span class="wt-cli-sr-only">Non-necessary</span></label>
                    </div>						</div>
						<div class="cli-tab-content">
							<div class="cli-tab-pane cli-fade" data-id="non-necessary">
								<div class="wt-cli-cookie-description">
									Any cookies that may not be particularly necessary for the website to function and is used specifically to collect user personal data via analytics, ads, other embedded contents are termed as non-necessary cookies. It is mandatory to procure user consent prior to running these cookies on your website.								</div>
							</div>
						</div>
					</div>
										</div>
	</div>
</div>
	  	</div>
	  	<div class="cli-modal-footer">
			<div class="wt-cli-element cli-container-fluid cli-tab-container">
				<div class="cli-row">
					<div class="cli-col-12 cli-align-items-stretch cli-px-0">
						<div class="cli-tab-footer wt-cli-privacy-overview-actions">
						
															<a id="wt-cli-privacy-save-btn" role="button" tabindex="0" data-cli-action="accept" class="wt-cli-privacy-btn cli_setting_save_button wt-cli-privacy-accept-btn cli-btn">SAVE & ACCEPT</a>
													</div>
						
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</div>
<div class="cli-modal-backdrop cli-fade cli-settings-overlay"></div>
<div class="cli-modal-backdrop cli-fade cli-popupbar-overlay"></div>
<!--googleon: all-->    <script type="text/javascript">
	var isProcessing = false;
    function alter_ul_post_values(obj,comment_id,ul_type,post_id){

		if (isProcessing)
		return;
		isProcessing = true;

		jQuery(obj).find("span").html("..");
    	jQuery.ajax({
   		type: "POST",
   		url: "https://propertyindustryeye.com/wp-content/plugins/like-dislike-counter-for-posts-pages-and-comments/ajax_counter.php",
   		data: "comment_id="+comment_id+"&up_type="+ul_type+"&post_id="+post_id,
   		success: function(msg){
     		jQuery(obj).find("span").html(msg);
			isProcessing = false;
   			}
 		});
	}
	</script>
            <script type="text/javascript">
            (function(){
                document.addEventListener('DOMContentLoaded', function(){
                    let wpp_widgets = document.querySelectorAll('.popular-posts-sr');

                    if ( wpp_widgets ) {
                        for (let i = 0; i < wpp_widgets.length; i++) {
                            let wpp_widget = wpp_widgets[i];
                            WordPressPopularPosts.theme(wpp_widget);
                        }
                    }
                });
            })();
        </script>
                <script>
            var WPPImageObserver = null;

            function wpp_load_img(img) {
                if ( ! 'imgSrc' in img.dataset || ! img.dataset.imgSrc )
                    return;

                img.src = img.dataset.imgSrc;

                if ( 'imgSrcset' in img.dataset ) {
                    img.srcset = img.dataset.imgSrcset;
                    img.removeAttribute('data-img-srcset');
                }

                img.classList.remove('wpp-lazyload');
                img.removeAttribute('data-img-src');
                img.classList.add('wpp-lazyloaded');
            }

            function wpp_observe_imgs(){
                let wpp_images = document.querySelectorAll('img.wpp-lazyload'),
                    wpp_widgets = document.querySelectorAll('.popular-posts-sr');

                if ( wpp_images.length || wpp_widgets.length ) {
                    if ( 'IntersectionObserver' in window ) {
                        WPPImageObserver = new IntersectionObserver(function(entries, observer) {
                            entries.forEach(function(entry) {
                                if (entry.isIntersecting) {
                                    let img = entry.target;
                                    wpp_load_img(img);
                                    WPPImageObserver.unobserve(img);
                                }
                            });
                        });

                        if ( wpp_images.length ) {
                            wpp_images.forEach(function(image) {
                                WPPImageObserver.observe(image);
                            });
                        }

                        if ( wpp_widgets.length ) {
                            for (var i = 0; i < wpp_widgets.length; i++) {
                                let wpp_widget_images = wpp_widgets[i].querySelectorAll('img.wpp-lazyload');

                                if ( ! wpp_widget_images.length && wpp_widgets[i].shadowRoot ) {
                                    wpp_widget_images = wpp_widgets[i].shadowRoot.querySelectorAll('img.wpp-lazyload');
                                }

                                if ( wpp_widget_images.length ) {
                                    wpp_widget_images.forEach(function(image) {
                                        WPPImageObserver.observe(image);
                                    });
                                }
                            }
                        }
                    } /** Fallback for older browsers */
                    else {
                        if ( wpp_images.length ) {
                            for (var i = 0; i < wpp_images.length; i++) {
                                wpp_load_img(wpp_images[i]);
                                wpp_images[i].classList.remove('wpp-lazyloaded');
                            }
                        }

                        if ( wpp_widgets.length ) {
                            for (var j = 0; j < wpp_widgets.length; j++) {
                                let wpp_widget = wpp_widgets[j],
                                    wpp_widget_images = wpp_widget.querySelectorAll('img.wpp-lazyload');

                                if ( ! wpp_widget_images.length && wpp_widget.shadowRoot ) {
                                    wpp_widget_images = wpp_widget.shadowRoot.querySelectorAll('img.wpp-lazyload');
                                }

                                if ( wpp_widget_images.length ) {
                                    for (var k = 0; k < wpp_widget_images.length; k++) {
                                        wpp_load_img(wpp_widget_images[k]);
                                        wpp_widget_images[k].classList.remove('wpp-lazyloaded');
                                    }
                                }
                            }
                        }
                    }
                }
            }

            document.addEventListener('DOMContentLoaded', function() {
                wpp_observe_imgs();

                // When an ajaxified WPP widget loads,
                // Lazy load its images
                document.addEventListener('wpp-onload', function(){
                    wpp_observe_imgs();
                });
            });
        </script>
        <script type='text/javascript' src='https://propertyindustryeye.com/wp-content/plugins/property-eye-adverts/js/unslider.js?ver=5399a202ce0691496d05523f56bbfa49' id='unslider-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/plugins/property-eye-adverts/js/slider.js?ver=5399a202ce0691496d05523f56bbfa49' id='slider-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/plugins/property-eye-newsletter/assets/js/pienewsletter.js' id='pienewsletter-js'></script>
<script type='text/javascript' src='https://unpkg.com/sweetalert/dist/sweetalert.min.js' id='sweet-alert-js'></script>
<script type='text/javascript' src='https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js' id='intl-tel-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/plugins/property-eye-user/assets/js/userpie.js?ver=1.22' id='userpie-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/js/plugins.js?ver=1.4.2' id='plugins-script-js'></script>
<script type='text/javascript' id='main-script-js-extra'>
/* <![CDATA[ */
var vars = {"ajaxurl":"https:\/\/propertyindustryeye.com\/wp-admin\/admin-ajax.php","templateurl":"https:\/\/propertyindustryeye.com\/wp-content\/themes\/propertyeyetheme"};
/* ]]> */
</script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/js/script.js?ver=1.4.2' id='main-script-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/js/navigation.js?ver=20120206' id='propertyeyetheme-navigation-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/themes/propertyeyetheme/js/skip-link-focus-fix.js?ver=20130115' id='propertyeyetheme-skip-link-focus-fix-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-includes/js/comment-reply.min.js?ver=5399a202ce0691496d05523f56bbfa49' id='comment-reply-js'></script>
<script type='text/javascript' id='yop-public-js-extra'>
/* <![CDATA[ */
var objectL10n = {"yopPollParams":{"urlParams":{"ajax":"https:\/\/propertyindustryeye.com\/wp-admin\/admin-ajax.php","wpLogin":"https:\/\/propertyindustryeye.com\/backoffice\/?redirect_to=https%3A%2F%2Fpropertyindustryeye.com%2Fwp-admin%2Fadmin-ajax.php%3Faction%3Dyop_poll_record_wordpress_vote"},"apiParams":{"reCaptcha":{"siteKey":""},"reCaptchaV2Invisible":{"siteKey":""},"reCaptchaV3":{"siteKey":""},"facebook":{"appId":""},"google":{"clientId":""}},"captchaParams":{"imgPath":"https:\/\/propertyindustryeye.com\/wp-content\/plugins\/yop-poll-pro\/public\/assets\/img\/","url":"https:\/\/propertyindustryeye.com\/wp-content\/plugins\/yop-poll-pro\/app.php","accessibilityAlt":"Sound icon","accessibilityTitle":"Accessibility option: listen to a question and answer it!","accessibilityDescription":"Type below the <strong>answer<\/strong> to what you hear. Numbers or words:","explanation":"Click or touch the <strong>ANSWER<\/strong>","refreshAlt":"Refresh\/reload icon","refreshTitle":"Refresh\/reload: get new images and accessibility option!"},"voteParams":{"invalidPoll":"Invalid Poll","noAnswersSelected":"No answer selected","minAnswersRequired":"At least {min_answers_allowed} answer(s) required","maxAnswersRequired":"A max of {max_answers_allowed} answer(s) accepted","noAnswerForOther":"No other answer entered","answerForOtherTooLong":"Answer for other is too long","noValueForCustomField":"{custom_field_name} is required","consentNotChecked":"You must agree to our terms and conditions","noCaptchaSelected":"Captcha is required","thankYou":"Thank you for your vote"},"resultsParams":{"singleVote":"vote","multipleVotes":"votes","singleAnswer":"answer","multipleAnswers":"answers"}}};
/* ]]> */
</script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-content/plugins/yop-poll-pro/public/assets/js/yop-poll-public-6.3.0.min.js?ver=5399a202ce0691496d05523f56bbfa49' id='yop-public-js'></script>
<script type='text/javascript' src='https://propertyindustryeye.com/wp-includes/js/wp-embed.min.js?ver=5399a202ce0691496d05523f56bbfa49' id='wp-embed-js'></script>
<script src='https://stats.wp.com/e-202309.js' defer></script>
<script>
	_stq = window._stq || [];
	_stq.push([ 'view', {v:'ext',j:'1:10.1',blog:'197689917',post:'122561',tz:'0',srv:'propertyindustryeye.com'} ]);
	_stq.push([ 'clickTrackerInit', '197689917', '122561' ]);
</script>

<script type="text/javascript">

    if(jQuery('.sce-comment-text').length) {

      tinymce.init( {
            mode : "exact",
            selector : '.sce-comment-text',
            theme: "modern",
            skin: "lightgray",
            menubar : false,
            statusbar : false,
            toolbar: [
                "bold italic underline"
            ],
            height : "300",
            setup: function (editor) {
                editor.on('change', function () {
                    editor.save();
                });
            },
            paste_auto_cleanup_on_paste : true
        } );

    }


</script>


</body>`

function Sample2() {
    const [isAllowed, setAllowed] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL + "/adduser";
    const requestPermission = async () => {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        setAllowed(true);
        sendToken();
      } else if (permission === "denied") {
        setAllowed(false);
      }
    };
  
    useEffect(() => {
      // Req user for notification permission
      requestPermission();
    }, []);
  
    const sendToken = async (isAdmin) => {
      const myToken = await getToken(messaging, vapidKey);
      const myUserAgent = navigator.userAgent;
      console.log("token here:",myToken);
      const mydata = JSON.stringify({
        token: myToken,
        userAgent: myUserAgent,
        isAdmin: isAdmin
      })
  
      const res = await axios({
        method: "post",
        url: API_URL,
        headers: { "content-type": "application/json" },
        data: mydata,
      })
    };
  
    return (
      <div>
        {isAllowed ? (
          <div dangerouslySetInnerHTML={{ __html: rawHTML }}></div>
        ) : (<div><div>Not Allowed!</div><div>Please allow Notifications and reload</div></div>
        
        )}
      </div>
    );
  }
  
  export default Sample2;